import { ActiveArea } from 'components/alphabet/styled'
import styled from 'styled-components/macro'
import { mq } from 'styles/mq'

export const Figure = styled.figure`
  margin: 0;

  img {
    width: 100%;
  }
`
export const Figcaption = styled.figcaption`
  font-size: 1.4rem;
  text-align: center;
  margin-top: 0.4em;
`

export const ImageWrapper = styled.div`
  position: relative;
  margin: 4rem 2rem;

  ${mq.medium} {
    margin: 4rem 5rem;
  }
`

export const StyledActiveArea = styled(ActiveArea)`
  --theme-color: rgba(149, 176, 214, 0.8);
  --height: 16.3%;
  --offset: 0;

  ${mq.medium} {
    --height: 25%;
  }

  &[data-char='ҕ'] {
    --row: 1;
    left: 52%;
    width: 16%;

    ${mq.medium} {
      --row: 1;
      left: 37%;
      width: 9.5%;
    }
  }

  &[data-char='ҥ'] {
    --row: 3;
    left: 41%;
    width: 14%;

    ${mq.medium} {
      --row: 2;
      left: 68%;
      width: 9.5%;
    }
  }

  &[data-char='Дь'] {
    --row: 1;
    left: 84%;
    width: 16%;

    ${mq.medium} {
      --row: 1;
      left: 57%;
      width: 13%;
    }
  }

  &[data-char='нь'] {
    --row: 3;
    left: 55%;
    width: 18%;

    ${mq.medium} {
      --row: 2;
      left: 77.5%;
      width: 14%;
    }
  }

  &[data-char='ө'] {
    --row: 3;
    left: 91%;
    width: 9%;

    ${mq.medium} {
      --row: 3;
      left: 0%;
      width: 5.5%;
    }
  }

  &[data-char='ү'] {
    --row: 4;
    left: 90%;
    width: 12%;

    ${mq.medium} {
      --row: 3;
      left: 63%;
      width: 9%;
    }
  }

  &[data-char='һ'] {
    --row: 4;
    left: 42%;
    width: 15%;

    ${mq.medium} {
      --row: 3;
      left: 35%;
      width: 9%;
    }
  }
`
